// 取り扱い製品ポータルページ用の共通モーダル
jQuery(function ($) {

  function closeModal($modal) {
    const activeElement = document.activeElement;

    if (
      activeElement &&
      $modal[0].contains(activeElement)
    ) {
      activeElement.blur();
    }

    $modal
      .removeClass('is-open')
      .attr('aria-hidden', 'true');

    $('body').removeClass('is-modal-open');
  }


  $(document).on('click', '[data-modal-target]', function () {

    const target = $(this).data('modal-target');
    const $modal = $('.productPage-areaModal[data-modal="' + target + '"]');

    if (!$modal.length) return;

    $modal
      .addClass('is-open')
      .attr('aria-hidden', 'false');

    $('body').addClass('is-modal-open');

    $modal.find('[data-modal-close]').first()[0]?.focus();
  });


  $(document).on(
    'click',
    '.productPage-areaModal [data-modal-close]',
    function () {

      const $modal = $(this).closest('.productPage-areaModal');

      closeModal($modal);
    }
  );


  $(document).on('keydown', function (event) {

    if (event.key !== 'Escape') return;

    const $modal = $('.productPage-areaModal.is-open');

    if (!$modal.length) return;

    closeModal($modal);
  });

});